import { axios } from './config';
import { ACCESS_CONTROL_CONSTANTS } from '../core/constants';

export const getAllSites = () => {
	return axios.get('/site/all');
};

export const getAllSiteTags = () => {
	return axios.get('/site/all-site-tags');
};

export const getAllTagAndSitePerc = () => {
	return axios.get('/site/allSiteTagsAndPercentage');
};

export const getSiteConfig = (siteId) => {
	return axios.get(`/site/${siteId}`);
};
// TODO: Take this payload in a single object as we follow throughout our code
export const updateSite = (params, siteId) => {
	const dataObject = {
		...params,
		system: ACCESS_CONTROL_CONSTANTS.SYSTEMS.FRAMERATE
	};

	return axios.put(`/admin/site/${siteId}`, dataObject);
};

export const createSite = (params) => {
	const dataObject = { ...params };
	return axios.post(`/admin/site/create`, dataObject);
};

export const getDoc = (docId) => {
	return axios.get(`/super-admin/getDoc/${docId}`, '');
};

export const updateDoc = (docId, data, previousCouchBaseConfig, mode) => {
	const dataObject = { data, previousCouchBaseConfig, mode };
	return axios.post(`/super-admin/updateDoc/${docId}`, dataObject);
};

export const siteSync = (siteId, data, previousCouchBaseConfig, mode, siteDomain) => {
	const dataObject = {
		data,
		previousCouchBaseConfig,
		mode,
		siteId,
		siteDomain
	};
	return axios.post('/site/sync', dataObject);
};

export const getTgmrDoc = (siteId) => {
	return axios.get(`/cb/tgmrDoc/${siteId}`);
};

export const syncDfpAdUnits = (payload) => {
	return axios.post('/site/syncDfpAdUnits', payload);
};

export const triggerNetworkWideSync = (payload) => {
	return axios.post('/site/syncNetworkWide', payload);
};

export const triggerSrSync = (payload) => {
	return axios.post('/site/syncSrSites', payload);
};

/**
 * @name logPullAndMerge
 * @description This is temporary api to log how often "Pull Latest Version" is used in dashboard to pull and merge latest inst doc.
 * Should be removed once analysis is done.
 * @param {number} siteId
 * @param {object} currentLocalSiteConfig
 * @param {"SUCCESS"|"FAILED"} status
 */
export const logPullAndMerge = (siteId, currentLocalSiteConfig, status) => {
	return axios.post(`/site/log-pullandmerge?siteId=${siteId}&status=${status}`, {
		data: currentLocalSiteConfig
	});
};
